import styled from "styled-components";
import Icon from "../../../../../components/Icon";

export const Separator = styled("div")<{ collapsed }>`
  height: 1px;
  background-color: rgba(45, 52, 54, 0.25);
  max-height: ${({ collapsed }) => (collapsed ? 0 : 1)}px;
`;

export const Collapse = styled("div")`
  overflow: hidden;
  padding: 12px 32px;
  transition: all 0.3s ease-out;
  background: #ffffff;
  border-radius: 12px;
`;

export const CollapseToggle = styled("button")`
  margin: 0px;
  padding: 12px 0px;
  border: none;
  background: none;
  cursor: pointer;
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
`;

export const CollapseContent = styled("div")<{
  collapsed;
  contentHeight;
}>`
  display: block;
  position: relative;
  height: ${({ contentHeight }) => contentHeight + "px"};
  max-height: ${({ collapsed, contentHeight }) =>
    collapsed ? 0 : contentHeight}px;
  transition: max-height 0.2s ease-in-out;
  overflow: hidden;
`;

export const ToggleIcon = styled(Icon)<{ collapsed }>`
  display: inline-block;
  vertical-align: -4px;
  transition: all 0.5s ease-in-out;
  transform: ${({ collapsed }) =>
    collapsed ? "rotate(0deg)" : "rotate(180deg)"};
`;

export const Arrow = styled("div")<{ isCollapsed }>`
  transition: transform 0.3s ease-in-out;
  transform: rotate(${({ isCollapsed }) => (isCollapsed ? "90deg" : "-90deg")});
`;
